import React from 'react'
import "./../Satisfaction/SatisfactionStyle.css"
import faces from "./../../Assets/faces.png"
import persons from "./../../Assets/persons.png"
import hand from "./../../Assets/hand.png"
import handshaking from "./../../Assets/handshaking.png"


function Satisfaction() {
  return (
    <div className=' satisfy_main'>

    <div className='satisfy_left'>
    
        <div className='icons_and_text '>
          <div> <img className='three_icons' src={faces}/> </div> 

          <div > <div className='icons_headings'>Client Satisfaction Guaranteed</div>
            <p className='below_icons_headings'>We pride ourselves on a world class experience. Inquire today to find out about our client satisfaction guarantee.</p>
          </div> 
        
        </div>


        <div className='icons_and_text '>
        <div> <img className='three_icons' src={persons}/> </div>
        <div> <div className='icons_headings'>Be a part of Our Community</div> 
              <p className='below_icons_headings'>Join the thousands of sellers we've helped get the cash they need.</p>
        </div>
        </div>

        <div className='icons_and_text '>
        <div> <img className='three_icons' src={hand}/> </div>
        <div ><div className='icons_headings'>Our Offer Won't Change</div>
             <p className='below_icons_headings'>Unlike websites that give you an online "offer" and then change it later - we'll provide you with a real cash offer that doesn't change at closing.</p>
        </div>
        </div>
    </div>


    <div className='satisfy_right'>
        <div className='handshake_left'></div>

        <div className='handshake_right mr-5'>
            <div className='handshaking_img_div'> <img className='handshaking_img' src={handshaking} /> </div>
            <div className='selling_home_text'>Selling<br/> Your Home Should Be Simple</div>
        </div>
    </div>
      
    </div>
  )
}

export default Satisfaction
